import classNames from "classnames";
import style from "./checkbox.module.css";
import { useCallback, useEffect, useState } from "react";

type CheckboxProps = {
  checked: boolean;
  onChange?: (checked: boolean) => void;
  theme?: "light" | "dark";
  disabled?: boolean;
};

export default function Checkbox({ checked, onChange, theme = "light", disabled }: CheckboxProps) {
  const [focused, setFocused] = useState(false);

  useEffect(() => {
    window.addEventListener("keydown", handleKeyboard);
    return () => window.removeEventListener("keydown", handleKeyboard);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [focused, checked]);

  const toggle = useCallback(() => onChange && onChange(!checked), [checked, onChange]);

  function handleKeyboard(e: KeyboardEvent) {
    if (!focused) {
      return;
    }
    if (e.code === "Space") {
      e.preventDefault();
      e.stopPropagation();
      toggle();
    }
  }

  return (
    <div
      className={classNames(style.container, style[theme], { [style.disabled]: disabled })}
      onClick={() => {
        if (disabled) return;
        toggle();
      }}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
    >
      <div className={classNames(style.checkbox, style[theme], { [style.checked]: checked })}>
        {checked && (
          <svg className={style.checkmark} viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 7.5L6.33333 10L11 5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
          </svg>
        )}
      </div>
    </div>
  );
}
